import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, Package, Megaphone, Home as HomeIcon, Tag, Image as ImageIcon } from "lucide-react";
import ProductsTab from "@/components/admin/ProductsTab";
import CampaignsTab from "@/components/admin/CampaignsTab";
import HeroPosterTab from "@/components/admin/HeroPosterTab";
import AboutImageTab from "@/components/admin/AboutImageTab";
import CategoriesTab from "@/components/admin/CategoriesTab";
import MarqueeTab from "@/components/admin/MarqueeTab";

export default function AdminDashboard() {
  const { user, loading, logout } = useAuth();
  const [tab, setTab] = useState("products");

  if (loading) {
    return <div className="p-10 text-center font-display text-2xl">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[var(--bg)] candy-dots" data-testid="admin-dashboard">
      {/* Top bar */}
      <header className="bg-white border-b-[3px] border-black sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-4 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[var(--primary)] border-[3px] border-black flex items-center justify-center font-display font-black text-white text-lg shadow-[3px_3px_0_0_#0A0A0A]">K</div>
            <div className="leading-tight">
              <div className="font-display font-black text-xl">KHASIM TRENDZ</div>
              <div className="text-xs font-bold uppercase tracking-wider text-black/60">Admin Dashboard</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" className="nb-pill" data-testid="admin-view-site"><HomeIcon size={14} strokeWidth={3} className="inline mr-1" /> View Site</Link>
            <button onClick={logout} className="nb-pill bg-black text-white" data-testid="admin-logout-btn"><LogOut size={14} strokeWidth={3} className="inline mr-1" /> Logout</button>
          </div>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-5 md:px-8 pb-4 flex gap-2 flex-wrap">
          <button
            onClick={() => setTab("products")} data-testid="tab-products"
            className={`nb-pill ${tab === "products" ? "bg-[var(--primary)] text-white" : ""}`}
          ><Package size={14} strokeWidth={3} className="inline mr-1" /> Products</button>
          <button
            onClick={() => setTab("categories")} data-testid="tab-categories"
            className={`nb-pill ${tab === "categories" ? "bg-[var(--primary)] text-white" : ""}`}
          ><Tag size={14} strokeWidth={3} className="inline mr-1" /> Categories</button>
          <button
            onClick={() => setTab("campaigns")} data-testid="tab-campaigns"
            className={`nb-pill ${tab === "campaigns" ? "bg-[var(--primary)] text-white" : ""}`}
          ><Megaphone size={14} strokeWidth={3} className="inline mr-1" /> Campaigns</button>
          <button
            onClick={() => setTab("marquee")} data-testid="tab-marquee"
            className={`nb-pill ${tab === "marquee" ? "bg-[var(--primary)] text-white" : ""}`}
          ><Tag size={14} strokeWidth={3} className="inline mr-1" /> Marquee</button>
          <button
            onClick={() => setTab("hero")} data-testid="tab-hero"
            className={`nb-pill ${tab === "hero" ? "bg-[var(--primary)] text-white" : ""}`}
          ><ImageIcon size={14} strokeWidth={3} className="inline mr-1" /> Hero Poster</button>
          <button
            onClick={() => setTab("about")} data-testid="tab-about"
            className={`nb-pill ${tab === "about" ? "bg-[var(--primary)] text-white" : ""}`}
          ><ImageIcon size={14} strokeWidth={3} className="inline mr-1" /> About Image</button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-5 md:px-8 py-8">
        {tab === "products" && <ProductsTab />}
        {tab === "categories" && <CategoriesTab />}
        {tab === "campaigns" && <CampaignsTab />}
        {tab === "marquee" && <MarqueeTab />}
        {tab === "hero" && <HeroPosterTab />}
        {tab === "about" && <AboutImageTab />}
      </main>
    </div>
  );
}
